import React, { useState, useEffect } from 'react';
import { createTextMessage } from '../../services/textMessageService';
// import Toast from '../common/Toast';
import { useParams, useNavigate } from 'react-router-dom';
import { createMessage, getCoupons } from '../../services/messageService';
import { toast } from 'react-toastify';

import axios from 'axios';

function TextMessageForm() {
  const [content, setContent] = useState('');
  const [scheduledDate, setScheduledDate] = useState('');
  const [recurrence, setRecurrence] = useState('none');
  const { restaurantId } = useParams();

  const [couponId, setCouponId] = useState('');
  const [coupons, setCoupons] = useState([]);

  useEffect(() => {
    const fetchCoupons = async () => {
      // console.log('erer');
      try {
        const token = localStorage.getItem('ownerToken');
        const { data } = await axios.get(
          `/api/restaurants/${restaurantId}/coupontemplates`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCoupons(data);
      } catch (error) {
        // showError('Failed to fetch coupons.');
        toast.error('Failed to schedule message');
      }
    };
    fetchCoupons();
  }, [restaurantId]);

  const handleSubmit = async (e) => {
    // const unsubscribeLink = `${process.env.REACT_APP_BASE_URL}/unsubscribe/${restaurantId}`;
    // const fullMessageContent = `${messageContent}\n\nUnsubscribe here: ${unsubscribeLink}`;

    e.preventDefault();
    try {
      await createTextMessage({
        content,
        scheduledDate,
        recurrence,
        couponId,
        restaurantId,
      });
      // Toast('Text message scheduled successfully', 'success');
    } catch (error) {
      // Toast('Failed to schedule text message', 'error');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>Message Content</label>
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Scheduled Date</label>
        <input
          type='datetime-local'
          value={scheduledDate}
          onChange={(e) => setScheduledDate(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Recurrence</label>
        <select
          value={recurrence}
          onChange={(e) => setRecurrence(e.target.value)}
        >
          <option value='none'>None</option>
          <option value='daily'>Daily</option>
          <option value='weekly'>Weekly</option>
          <option value='monthly'>Monthly</option>
        </select>
        <select value={couponId} onChange={(e) => setCouponId(e.target.value)}>
          <option value=''>Select a Coupon</option>
          {coupons.map((coupon) => (
            <option key={coupon._id} value={coupon._id}>
              {coupon.description}
            </option>
          ))}
        </select>
      </div>
      <button type='submit'>Schedule Message</button>
    </form>
  );
}

export default TextMessageForm;

// import React, { useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { createTextMessage } from '../../services/textMessageService';
// import Toast from '../common/Toast';

// function TextMessageForm() {
//   const { restaurantId } = useParams();
//   const [content, setContent] = useState('');
//   const [scheduledDate, setScheduledDate] = useState('');

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await createTextMessage(restaurantId, { content, scheduledDate });
//       Toast.success('Text message scheduled successfully.');
//     } catch (error) {
//       Toast.error('Failed to schedule text message.');
//     }
//   };

//   return (
//     <div className="p-6">
//       <h1 className="text-2xl font-bold mb-4">Schedule a Text Message</h1>
//       <form onSubmit={handleSubmit}>
//         <div className="mb-4">
//           <label className="block text-sm font-medium text-gray-700">Message Content</label>
//           <textarea
//             value={content}
//             onChange={(e) => setContent(e.target.value)}
//             className="w-full p-2 border rounded"
//             rows="4"
//             required
//           />
//         </div>
//         <div className="mb-4">
//           <label className="block text-sm font-medium text-gray-700">Scheduled Date</label>
//           <input
//             type="datetime-local"
//             value={scheduledDate}
//             onChange={(e) => setScheduledDate(e.target.value)}
//             className="w-full p-2 border rounded"
//             required
//           />
//         </div>
//         <button
//           type="submit"
//           className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
//         >
//           Schedule Message
//         </button>
//       </form>
//     </div>
//   );
// }

// export default TextMessageForm;
